import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { API } from 'aws-amplify';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [MessageService]
})
export class DashboardComponent implements OnInit {

  applications: any[] = new Array();
  leads: any[] = new Array();

  deletingLead: boolean = false;
  gettingLeads: boolean = false;
  gettingApplications: boolean = false;

  tagText: string;
  showTagDialog: boolean = false;
  addingTag: boolean = false;
  addingTagApplicationId: string;
  addingTagEmailPerson: string;
  addingTagAllTags: any[] = new Array();

  constructor(private messageService: MessageService, private router: Router) { }

  ngOnInit(): void {
    this.getLoanLeads();
    this.getApplications();
  }

  async getLoanLeads() {
    this.gettingLeads = true;
    const params = {
      body: {
      }
    }

    var leadsResponse = await API.post('ckprivateapi', '/api/get-loan-leads', params);

    if (leadsResponse.success) {
      this.leads = leadsResponse.leads;
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'error', detail: leadsResponse.message});
    }

    this.gettingLeads = false;
  }

  async getApplications() {
    this.gettingApplications = true;
    const params = {
      body: {
      }
    }

    var applicationResponse = await API.post('ckprivateapi', '/api/get-loan-applications', params);

    if (applicationResponse.success) {
      this.applications = applicationResponse.applications
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'error', detail: applicationResponse.message});
    }

    this.gettingApplications = false;
  }

  openAddNewTag(id, email, tags) {
    this.tagText = "";
    this.showTagDialog = true;
    this.addingTagApplicationId = id;
    this.addingTagEmailPerson = email;
    this.addingTagAllTags = tags;
  }

  async removeTag(id, email, tags, tagToRemove) {
    this.messageService.clear();
    this.addingTag = true;
    tags = tags.filter(x => x !== tagToRemove);

    const params = {
      body: {
        email: email,
        id: id,
        tags: tags
      }
    }

    var tagResponse = await API.post('ckprivateapi', '/api/add-application-tag', params);

    if (tagResponse.success) {
      this.messageService.add({ key: 'tst', severity: 'success', summary: 'Application Updated', detail: 'Updated'});
      this.showTagDialog = false;
      this.getApplications();
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'error', detail: tagResponse.message});
    }

    this.addingTag = false;
  }

  async addNewTag() {
    this.messageService.clear();
    this.addingTag = true;
    if (this.addingTagAllTags && this.addingTagAllTags.length > 0) {
      this.addingTagAllTags.push(this.tagText);
    }
    else {
      this.addingTagAllTags = [this.tagText];
    }
    
    const params = {
      body: {
        email: this.addingTagEmailPerson,
        id: this.addingTagApplicationId,
        tags: this.addingTagAllTags
      }
    }

    var tagResponse = await API.post('ckprivateapi', '/api/add-application-tag', params);

    if (tagResponse.success) {
      this.messageService.add({ key: 'tst', severity: 'success', summary: 'Application Updated', detail: 'Updated'});
      this.showTagDialog = false;
      this.getApplications();
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'error', detail: tagResponse.message});
    }

    this.addingTag = false;
  }

  async markApplicationComplete(id, email) {
    this.messageService.clear();
    const params = {
      body: {
        email: email,
        id: id,
      }
    }

    var response = await API.post('ckprivateapi', '/api/application-complete', params);

    if (response.success) {
      this.messageService.add({ key: 'tst', severity: 'success', summary: 'Application Updated', detail: 'Updated'});
      this.getApplications();
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'error', detail: response.message});
    }
  }

  async markApplicationCancelled(id, email) {
    this.messageService.clear();
    const params = {
      body: {
        email: email,
        id: id,
      }
    }

    var response = await API.post('ckprivateapi', '/api/application-cancelled', params);

    if (response.success) {
      this.messageService.add({ key: 'tst', severity: 'success', summary: 'Application Updated', detail: 'Updated'});
      this.getApplications();
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'error', detail: response.message});
    }
  }

  async clearStatus(id, email) {
    this.messageService.clear();
    const params = {
      body: {
        email: email,
        id: id,
      }
    }

    var response = await API.post('ckprivateapi', '/api/clear-status', params);

    if (response.success) {
      this.messageService.add({ key: 'tst', severity: 'success', summary: 'Application Updated', detail: 'Updated'});
      this.getApplications();
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'error', detail: response.message});
    }
  }

  viewSpecificApplication(email, id) {
    this.router.navigate(['/dashboard/application'], { queryParams: { email: email, id: id } });
  }

  async deleteLead(pk, sk) {
    this.messageService.clear();
    this.deletingLead = true;
    console.log(pk);
    console.log(sk);
    const params = {
      body: {
        pk: pk,
        sk: sk,
      }
    }

    var response = await API.post('ckprivateapi', '/api/delete-loan-lead', params);

    if (response.success) {
      this.messageService.add({ key: 'tst', severity: 'success', summary: 'Deleted', detail: 'Deleated the lead'});
      this.getLoanLeads();
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'error', detail: response.message});
    }

    this.deletingLead = false;
  }

  async downloadSpecificApplicationData(email, id) {
    const params = {
      body: {
        email: email,
        id: id
      }
    }

    var applicationResponse = await API.post('ckprivateapi', '/api/get-specific-application', params);

    if (applicationResponse.success) {
      if (applicationResponse.application) {
        var csv = this.downloadFile([applicationResponse.application.Application], Object.keys(applicationResponse.application.Application), applicationResponse.application.id)
      }
      else {
        this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'This application was not found'});
      }
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'error', detail: applicationResponse.message});
    }
  }

  ConvertToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = 'Row Num,';
    for (let index in headerList) {
     row += headerList[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
     let line = (i+1)+'';
     for (let index in headerList) {
      let head = headerList[index];
      line += ',' + array[i][head];
     }
     str += line + '\r\n';
    }
    return str;
   }

   downloadFile(data, keys, filename='data') {
    let csvData = this.ConvertToCSV(data, keys);
    console.log(csvData)
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
}

}
